import React, { useState } from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { fetchData } from '@/fetchapi/fetchapi';

export default function DeleteDataSourceDialog({ isOpen, onClose, onSuccess, source }) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setIsDeleting(true);
    setError(null);
    try {
      // The unified Sources list returns namespaced ids ('ds-<n>' / 'dt-<n>')
      // with the real row id in entity_id and the table in origin. Deleting by
      // the namespaced id against the numeric PK silently deleted NOTHING —
      // route by origin to the cascading delete (row + load/save node + links
      // + mappings).
      const entityId = source.entity_id ?? String(source.id).replace(/^d[st]-/, '');
      const table = source.origin === 'data_target' ? 'data_target' : 'data_source';
      await fetchData(`${table}/${entityId}`, { method: 'DELETE' });
      onSuccess();
    } catch (err) {
      console.error('Failed to delete data source:', err);
      setError(err?.message || 'Failed to delete — see console for details.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete the data source '{source?.source_name}', its pipeline node and its field mappings.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {error && <div className="text-sm text-red-600">{error}</div>}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button onClick={handleDelete} disabled={isDeleting} className="bg-red-600 hover:bg-red-700">
              {isDeleting ? 'Deleting...' : 'Yes, delete source'}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
